<script lang="ts">
import { defineBlock } from '@bagelink/blox'
import { defineSchema, $ } from '@bagelink/vue'
const defaults = {
	priceMsg: '',
	btnTxt: 'Buy Now',
	link: '',
	priceInfo: '',
}
const schema = defineSchema({
	priceMsg: $.richtext('Price Message', { simple: true }),
	btnTxt: $.text('Button Text'),
	link: $.text('Buy Link'),
	priceInfo: $.richtext('Price Info', { simple: true }),
})
export const StoreBuyBox = defineBlock({
	thumbnail: '/block-thumbs/StoreBuyBox.svg',
	category: 'CTA',
	order: 360,
	name: 'StoreBuyBox',
	label: 'Store Buy Box',
	icon: 'shopping_cart',
	schema,
	defaults,
})
</script>
<script setup lang="ts">


import BlockCTA from '@/components/blocks/BlockCTA.vue'

// Kept for CMS backward-compatibility. Delegates to the generic `BlockCTA`.



const props = defineProps<{
	priceMsg?: string
	btnTxt?: string
	link?: string
	priceInfo?: string
}>()
</script>

<template>
	<BlockCTA v-bind="props" />
</template>
